import Cliente from "../mapper/Cliente";
import {db} from "../script/Fetch";
import FirestoreDbQueries from "./FirestoreDbQueries";
import servicesProvider from "../services/ServicesProvider";
import firebase from 'firebase/app';

export default class ClienteDbQueries extends FirestoreDbQueries<Cliente> {
    listener?: () => void;
    clienteList: { [key: string]: Cliente } = {};

    startListenClienteByRistoranteId(ristoranteId: string) {
        this.listener = db.collection("clienti")
            .where("idRistorante", "==", ristoranteId)
            .where("connesso", "not-in", [2])
            .onSnapshot(snapshot => {
                snapshot.docChanges().forEach((change) => {
                    this.clienteList[change.doc.id] = this.convertFromFirestore(change.doc.id, change.doc.data());
                    servicesProvider.getOrdineDbQueries().startListenOrdiniByClienteId(change.doc.id);
                    this.notify();
                });
            });

        if (Object.values(this.clienteList).length > 0) {
            this.notify();
        }
    }

    stopListenCliente() {
        if (this.listener === undefined) {
            return;
        }

        this.listener();
    }

    notify(): void {
        this.instances.forEach(instance => {
            instance.updateCliente(this.clienteList);
        });
    }

    async selectById(id: string) {
        let docSnapshot = await db.collection("clienti").doc(id).get();
        return await docSnapshot.data();
    }

    convertFromFirestore(documentId: string, firestoreObject: firebase.firestore.DocumentData): Cliente {
        let result: Cliente = new Cliente();
        result.documentId = documentId;
        result.authorized = firestoreObject.authorized;
        result.codiceTavolo = firestoreObject.codiceTavolo;
        result.connesso = firestoreObject.connesso;
        result.data = (firestoreObject.data as firebase.firestore.Timestamp).toDate();
        result.idRistorante = firestoreObject.idRistorante;
        result.idUtente = firestoreObject.idUtente;
        result.nClienti = firestoreObject.nClienti;
        result.nCopertiPagati = firestoreObject.nCopertiPagati;
        result.pagato = firestoreObject.pagato;
        result.recensione = firestoreObject.recensione;
        return result;
    }

    convertToFirestore(object: Cliente) {
        let mapperObject: any = {};
        mapperObject.authorized = object.authorized;
        mapperObject.codiceTavolo = object.codiceTavolo;
        mapperObject.connesso = object.connesso;
        mapperObject.data = firebase.firestore.Timestamp.fromDate(object.data);
        mapperObject.idRistorante = object.idRistorante;
        mapperObject.idUtente = object.idUtente;
        mapperObject.nClienti = object.nClienti;
        mapperObject.nCopertiPagati = object.nCopertiPagati;
        mapperObject.pagato = object.pagato;
        mapperObject.recensione = object.recensione;
        return mapperObject;
    }
}